// Project (Pod) page tabs per app. The "Cahier" tab (FEC import, revision workbook) belongs to the
// accounting product; the three assistant apps built from this fork (NEXT_PUBLIC_MARQUE set to
// pirouette, boosts or electron) never offer it. Without a brand, or with any other brand, the
// accounting product keeps it unchanged.

const MARQUES_ASSISTANT: ReadonlySet<string> = new Set([
  "pirouette",
  "boosts",
  "electron",
]);

const ONGLET_CAHIER = "cahier";
const ONGLET_PAR_DEFAUT = "conversations";

/** Whether the project page offers the accounting "Cahier" tab for the SPA brand. */
export function ongletCahierPropose(
  marque: string | undefined = process.env.NEXT_PUBLIC_MARQUE
): boolean {
  return !(typeof marque === "string" && MARQUES_ASSISTANT.has(marque));
}

/** Whether a tab id (system tab or file tab) may be shown for the SPA brand. */
export function ongletProjetPermis(
  onglet: string,
  marque: string | undefined = process.env.NEXT_PUBLIC_MARQUE
): boolean {
  return onglet !== ONGLET_CAHIER || ongletCahierPropose(marque);
}

/**
 * The tab actually shown: a "cahier" deep link or stored preference falls back to
 * "conversations" when the brand does not offer it.
 */
export function ongletProjetRetenu<T extends string>(
  onglet: T,
  marque: string | undefined = process.env.NEXT_PUBLIC_MARQUE
): T | typeof ONGLET_PAR_DEFAUT {
  return ongletProjetPermis(onglet, marque) ? onglet : ONGLET_PAR_DEFAUT;
}

/**
 * Whether the Projects (Pods) feature is offered at all for the SPA brand. Since 10/10 (Louka),
 * the three assistant apps hide it: the sidebar section, and the "where to create this
 * conversation" field of the schedule and webhook sheets. The accounting product keeps it.
 */
export function projetsProposes(
  marque: string | undefined = process.env.NEXT_PUBLIC_MARQUE
): boolean {
  return !(typeof marque === "string" && MARQUES_ASSISTANT.has(marque));
}
